// Arbre d'un programme Python du lycée (refonte lot 5.7, moteur v28).

export type Expr =
  | { k: 'num'; text: string; line: number }
  | { k: 'str'; v: string; line: number }
  | { k: 'const'; v: 'True' | 'False' | 'None'; line: number }
  | { k: 'name'; id: string; line: number }
  | { k: 'list'; items: Expr[]; line: number }
  | { k: 'tuple'; items: Expr[]; line: number }
  | { k: 'comp'; elt: Expr; target: Target; iter: Expr; cond: Expr | null; line: number }
  | { k: 'unary'; op: '-' | '+' | 'not'; e: Expr; line: number }
  | { k: 'bin'; op: BinOp; l: Expr; r: Expr; line: number }
  | { k: 'bool'; op: 'and' | 'or'; l: Expr; r: Expr; line: number }
  | { k: 'compare'; first: Expr; ops: CmpOp[]; rest: Expr[]; line: number }
  | { k: 'call'; f: Expr; args: Expr[]; line: number }
  | { k: 'index'; e: Expr; i: Expr; line: number }
  | {
      k: 'slice';
      e: Expr;
      lo: Expr | null;
      hi: Expr | null;
      step: Expr | null;
      line: number;
    }
  | { k: 'attr'; e: Expr; name: string; line: number }
  | { k: 'ifexp'; test: Expr; body: Expr; orelse: Expr; line: number };

export type BinOp = '+' | '-' | '*' | '/' | '//' | '%' | '**';
export type CmpOp = '<' | '>' | '<=' | '>=' | '==' | '!=' | 'in' | 'not in';

export type Target =
  | { k: 'name'; id: string; line: number }
  | { k: 'tuple'; items: Target[]; line: number }
  | { k: 'index'; e: Expr; i: Expr; line: number };

export type Stmt =
  | { k: 'assign'; targets: Target[]; value: Expr; line: number }
  | { k: 'aug'; target: Target; op: BinOp; value: Expr; line: number }
  | { k: 'expr'; e: Expr; line: number }
  | { k: 'if'; test: Expr; body: Stmt[]; orelse: Stmt[]; line: number; elif?: boolean }
  | { k: 'while'; test: Expr; body: Stmt[]; line: number }
  | { k: 'for'; target: Target; iter: Expr; body: Stmt[]; line: number }
  | { k: 'def'; name: string; params: string[]; body: Stmt[]; line: number }
  | { k: 'return'; value: Expr | null; line: number }
  | { k: 'import'; names: string[]; from: string | null; line: number }
  | { k: 'pass'; line: number }
  | { k: 'break'; line: number }
  | { k: 'continue'; line: number };

export interface Module {
  body: Stmt[];
}

/** instruction composée (bloc indenté) */
export const isCompound = (s: Stmt): boolean =>
  s.k === 'if' || s.k === 'while' || s.k === 'for' || s.k === 'def';
